module.exports = __webpack_public_path__ + "static/media/user_edit.43551fe3.svg";